import axios from "axios";
import { API_ROUTE, headersRequest } from "../../../helpers";

export const StatusDatyServices = {
  updateStatusDay: async (data) => {
    try {
      const result = await axios.put(
        `${API_ROUTE}status-day`,
        data,
        headersRequest()
      );
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
};
